import { render, staticRenderFns } from "./ContainerPacking.vue?vue&type=template&id=0333dab4"
import script from "./ContainerPacking.vue?vue&type=script&lang=js"
export * from "./ContainerPacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports